import { render, staticRenderFns } from "./FCCProperty.vue?vue&type=template&id=076ac634&scoped=true"
import script from "./FCCProperty.vue?vue&type=script&lang=js"
export * from "./FCCProperty.vue?vue&type=script&lang=js"
import style0 from "./FCCProperty.vue?vue&type=style&index=0&id=076ac634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076ac634",
  null
  
)

export default component.exports